import React, { FC } from 'react';
import { Skeleton } from '@mofid-securities/uikit';
import { FundCoverBackground } from './FundCoverBackground';

export const FundCoverSkeleton: FC = () => {
  return (
    <div className="relative flex w-full flex-col items-center justify-center gap-y-3 p-4">
      <FundCoverBackground />
      <Skeleton height={56} width={56} isCircle />
      <Skeleton height={22} width={160} />
      <Skeleton height={18} width={150} />
    </div>
  );
};
